<script>
    import app from "./stores/app";
    import {SENT_VIA} from "./lib/constants";
    import {createEventDispatcher} from 'svelte';
    import {formatDate} from './lib/lib';

    export let client;

    let lastLogin = "";
    let lastSent = "";

    const dispatch = createEventDispatcher();

    const deleteClick = () => {
        dispatch('delete', {
            id: client.id, name: client.name + ' ' + client.lastname
        });
    }

    $: {
        lastLogin = formatDate(client.last_login, 'd-m-y h:m');
        lastSent = formatDate(client.last_sent, 'd-m-y h:m');
    }
</script>

<tr class="pointer" class:selected={ $app.selectedClientId == client.id }
    on:click="{ () => app.editClient(client.id) }">
    <td class="row-header">
        {#if client.name === client.lastname}
            { client.name }
        {:else}
            { client.lastname } { client.name }
        {/if}
    </td>
    <td class="data">
        <span class="caption">Λογαριασμός:</span><span class="value">{ client.username }</span>
    </td>
    <td class="data">
        <span class="caption">Email:</span><span class="value">{ client.email }</span>
    </td>
    <td class="data">
        <span class="caption">Αποστολέας:</span><span class="value">{ client.originator }</span>
    </td>
    <td class="data">
        <span class="caption">Provider:</span><span class="value">{ client.provider }</span>
    </td>
    <td class="data text-right">
        <span class="caption">Μονάδες:</span><span class="value">{ client.credits }</span>
    </td>
    <td class="data">
        {#if lastSent}
            <span class="caption">Τελ. αποστολή:</span><span class="value">{ lastSent }
            {#if client.last_sent_via}
                ({ SENT_VIA[client.last_sent_via] })
            {/if}
            </span>
        {/if}
    </td>
    <td class="data last">
        <span class="caption">Είσοδος:</span><span class="value">{ lastLogin }</span>
    </td>
    <td class="row-actions" style="width:80px;">
        <span title="Ιστορικό μονάδων" on:click|stopPropagation="{ () => app.clientCreditsHistory(client) }"><i
                class="fa fa-history"></i></span>
        <span class="delete" title="Διαγραφή πελάτη" on:click|stopPropagation="{ deleteClick }"><i
                class="fa fa-trash-o"></i></span>
    </td>
</tr>